import SidebarUserInfo from "../SidebarUserInfo/SidebarUserInfo";

import {
  selectAccessFromInternet,
  selectUserInfo,
} from "../../App/module/selectors";
import { showAndCloseSidebar } from "./module/actions";
import { selectShowSidebar } from "./module/selector";

import { push } from "connected-react-router";
import { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { UserSections } from "../../models/User";
import { ROUTES } from "../../module/constants";
import { ISidebarProps } from "./module/constants";

import { FormattedMessage } from "react-intl";
import messages from "./module/messages";

import nexiWhiteLogo from "../../assets/images/Logo_Nexi_Group_Orizz_Bianco.png";
import classes from "./Sidebar.module.scss";

import { BiArrowBack } from "react-icons/bi";
import {
  FaClock,
  FaLockOpen,
  FaQuestion,
  FaTasks,
  FaUnlockAlt,
} from "react-icons/fa";
import { CgDanger } from "react-icons/cg";
import { RiRobotLine } from "react-icons/ri";
import {
  MdAddAlert,
  MdAdminPanelSettings,
  MdHistory,
  MdHome,
  MdManageAccounts,
  MdMenuBook,
  MdNotes,
  MdOutlineFactCheck,
  MdOutlineLibraryBooks,
  MdOutlineManageSearch,
  MdOutlinePersonAddAlt,
  MdOutlinePersonSearch,
  MdOutlinePostAdd,
  MdOutlineSettings,
  MdWysiwyg,
} from "react-icons/md";

const Sidebar = (props: ISidebarProps) => {
  const { show, showSidebar, changeLocation, userInfo, isFromInternet } = props;

  const [showConsoleAdmin, setShowConsoleAdmin] = useState(false);

  useEffect(() => {
    if (isFromInternet) {
      setShowConsoleAdmin(false);
    } else {
      setShowConsoleAdmin(true);
    }
  }, [isFromInternet]);

  return (
    <div
      className={
        show ? classes["Sidebar-wrapper__closed"] : classes["Sidebar-wrapper"]
      }
    >
      <div className={classes.action}>
        <BiArrowBack
          className={classes["close-menu"]}
          onClick={() => showSidebar(false)}
        />
      </div>
      <div className={classes["logo-wrapper"]}>
        <img className={classes.logo} src={nexiWhiteLogo} alt="logo-img" />
      </div>

      <div className={classes["user-info"]}>
        <SidebarUserInfo user={userInfo} />
      </div>
      {}
      <div className={classes.listContainer}>
        <ul>
          <li
            onClick={() => {
              changeLocation(ROUTES.WELCOME);
              showSidebar(false);
            }}
          >
            <MdHome />
            <FormattedMessage {...messages.homepage} />
          </li>
        </ul>
        <hr />

        {}

        {userInfo.sections &&
          (userInfo.sections.includes(UserSections.HISTORY_REQUEST) ||
            userInfo.sections.includes(UserSections.EXAMINE_USERS) ||
            userInfo.sections.includes(UserSections.EXAMINE_ENTITLEMENTS)) && (
            <>
              <ul>
                {userInfo.sections &&
                  userInfo.sections.includes(UserSections.HISTORY_REQUEST) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.REQUESTHISTORY);
                        showSidebar(false);
                      }}
                    >
                      <MdHistory />
                      <FormattedMessage {...messages.requestHistory} />
                    </li>
                  )}

                {userInfo.sections &&
                  userInfo.sections.includes(UserSections.EXAMINE_USERS) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.USERSREFERENCE);
                        showSidebar(false);
                      }}
                    >
                      <MdOutlinePersonSearch />
                      <FormattedMessage {...messages.users} />
                    </li>
                  )}

                {userInfo.sections &&
                  userInfo.sections.includes(
                    UserSections.EXAMINE_ENTITLEMENTS
                  ) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.ENTITLEMENT_REFERENCE);
                        showSidebar(false);
                      }}
                    >
                      <MdOutlineManageSearch />
                      <FormattedMessage {...messages.entitlementReference} />
                    </li>
                  )}
                {}
                {userInfo.sections &&
                  userInfo.sections.includes(
                    UserSections.USER_ENTITLEMENTS
                  ) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.USER_ENTITLEMENT);
                        showSidebar(false);
                      }}
                    >
                      {}
                      <MdOutlineManageSearch />
                      <FormattedMessage {...messages.userEntitlements} />
                    </li>
                  )}
              </ul>
              <hr />
            </>
          )}

        {}

        {userInfo.sections &&
          (userInfo.sections.includes(UserSections.CATALOG) ||
            userInfo.sections.includes(UserSections.USER_ENTITLEMENT_REQUEST) ||
            userInfo.sections.includes(UserSections.TEMPORARY_ABILITATIONS) ||
            userInfo.sections.includes(UserSections.RACF_USER)) && (
            <>
              <ul>
                {userInfo.sections &&
                  userInfo.sections.includes(UserSections.CATALOG) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.CATALOG);
                        showSidebar(false);
                      }}
                    >
                      <MdOutlineLibraryBooks />
                      <FormattedMessage {...messages.catalog} />
                    </li>
                  )}

                {userInfo.sections &&
                  userInfo.sections.includes(
                    UserSections.USER_ENTITLEMENT_REQUEST
                  ) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.ABILITATIONREQUEST);
                        showSidebar(false);
                      }}
                    >
                      <MdOutlinePostAdd />
                      <FormattedMessage {...messages.enablingRequest} />
                    </li>
                  )}

                {userInfo.sections &&
                  userInfo.sections.includes(
                    UserSections.TEMPORARY_ABILITATIONS
                  ) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.TEMPORARY_ABILITATIONS);
                        showSidebar(false);
                      }}
                    >
                      <FaClock />
                      <FormattedMessage {...messages.temporaryAbilitations} />
                    </li>
                  )}

                {userInfo.sections &&
                  userInfo.sections.includes(UserSections.RACF_USER) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.EMERGENCY_USERS);
                        showSidebar(false);
                      }}
                    >
                      {}
                      <CgDanger />
                      <FormattedMessage {...messages.emergencyUsers} />
                    </li>
                  )}
                {}
                {}
                <li
                  onClick={() => {
                    changeLocation(ROUTES.TECHNICAL_USERS);
                    showSidebar(false);
                  }}
                >
                  <RiRobotLine />
                  <FormattedMessage {...messages.technicalUsers} />
                </li>
                {}
              </ul>

              <hr />
            </>
          )}
        {}

        {userInfo.sections &&
          (userInfo.sections.includes(UserSections.DELEGATIONS) ||
            userInfo.sections.includes(UserSections.APPROVALS) ||
            userInfo.sections.includes(UserSections.TASK) ||
            userInfo.sections.includes(UserSections.SERVICE_REQUEST) ||
            userInfo.sections.includes(UserSections.REPORTS) ||
            userInfo.sections.includes(UserSections.MANUALS) ||
            userInfo.sections.includes(UserSections.EXTERNAL_PORTAL) ||
            userInfo.sections.includes(UserSections.CONSOLE_ADMIN)) && (
            <>
              <ul>
                {userInfo.sections.includes(UserSections.DELEGATIONS) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.DELEGATES);
                      showSidebar(false);
                    }}
                  >
                    <MdOutlinePersonAddAlt />
                    <FormattedMessage {...messages.delegates} />
                  </li>
                )}

                {userInfo.sections.includes(UserSections.APPROVALS) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.APPROVALS);
                      showSidebar(false);
                    }}
                  >
                    <MdOutlineFactCheck />
                    <FormattedMessage {...messages.approvals} />
                  </li>
                )}

                {userInfo.sections.includes(UserSections.TASK) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.TASKS);
                      showSidebar(false);
                    }}
                  >
                    <FaTasks />
                    <FormattedMessage {...messages.task} />
                  </li>
                )}

                {userInfo.sections.includes(UserSections.SERVICE_REQUEST) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.SERVICE_REQUEST);
                      showSidebar(false);
                    }}
                  >
                    <FaQuestion />
                    <FormattedMessage {...messages.serviceRequest} />
                  </li>
                )}

                {userInfo.sections.includes(UserSections.REPORTS) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.REPORT);
                      showSidebar(false);
                    }}
                  >
                    <MdNotes />
                    <FormattedMessage {...messages.report} />
                  </li>
                )}

                {userInfo.sections.includes(UserSections.MANUALS) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.MANUALS);
                      showSidebar(false);
                    }}
                  >
                    <MdMenuBook />
                    <FormattedMessage {...messages.manuals} />
                  </li>
                )}

                {userInfo.sections.includes(UserSections.EXTERNAL_PORTAL) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.EXTERNAL_PORTAL);
                      showSidebar(false);
                    }}
                  >
                    <MdWysiwyg />
                    <FormattedMessage {...messages.externalPortal} />
                  </li>
                )}

                {showConsoleAdmin &&
                  userInfo.sections.includes(UserSections.CONSOLE_ADMIN) && (
                    <li
                      onClick={() => {
                        changeLocation(ROUTES.CONSOLE_ADMIN);
                        showSidebar(false);
                      }}
                    >
                      <MdOutlineSettings />
                      <FormattedMessage {...messages.consoleAdmin} />
                    </li>
                  )}
              </ul>
            </>
          )}
        {}

        {userInfo.sections &&
          userInfo.sections.includes(UserSections.BUSINESS_ROLE) && (
            <Fragment>
              <hr />
              <ul>
                <li
                  onClick={() => {
                    changeLocation(ROUTES.BR_MANAGEMENT);
                    showSidebar(false);
                  }}
                >
                  <MdOutlinePersonAddAlt />
                  <FormattedMessage {...messages.brManagement} />
                </li>
              </ul>

              <hr />
            </Fragment>
          )}

        {}

        <ul>
          {userInfo.sections &&
            userInfo.sections.includes(UserSections.PROFILE_MGMT) && (
              <li
                onClick={() => {
                  changeLocation(ROUTES.PROFILE_MGMT);
                  showSidebar(false);
                }}
              >
                <MdManageAccounts />
                <FormattedMessage {...messages.profileManagement} />
              </li>
            )}
          {userInfo.sections &&
            userInfo.sections.includes(UserSections.RESET_PWD) && (
              <li
                onClick={() => {
                  changeLocation(ROUTES.RESET_PASSWORD);
                  showSidebar(false);
                }}
              >
                <FaUnlockAlt />
                <FormattedMessage {...messages.resetPassword} />
              </li>
            )}
          {userInfo.sections &&
            userInfo.sections.includes(UserSections.CHANGE_PWD) && (
              <li
                onClick={() => {
                  changeLocation(ROUTES.CHANGE_PASSWORD);
                  showSidebar(false);
                }}
              >
                <FaLockOpen />
                <FormattedMessage {...messages.changePassword} />
              </li>
            )}
        </ul>

        {}

        {userInfo.sections &&
          userInfo.sections.includes(UserSections.EXAMINE_CAMPAIGN) && (
            <Fragment>
              <hr />
              <ul>
                {userInfo.sections.includes(UserSections.EXAMINE_CAMPAIGN) && (
                  <li
                    onClick={() => {
                      changeLocation(ROUTES.CERTIFICATION_REFERENCE);
                      showSidebar(false);
                    }}
                  >
                    <MdAdminPanelSettings />
                    <FormattedMessage {...messages.examineRecertification} />
                  </li>
                )}
              </ul>
            </Fragment>
          )}
      </div>
    </div>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    show: selectShowSidebar,
    userInfo: selectUserInfo,
    isFromInternet: selectAccessFromInternet,
  });

const mapDispatchToProps: any = {
  changeLocation: (url: any) => push(url),
  showSidebar: (show: boolean) => showAndCloseSidebar(show),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Sidebar);
